import React, { useState, useContext, useRef } from 'react';
import { createPortal } from 'react-dom';
import styles from './index.module.scss';
import GasTrendModal from '../Modals/GasTrendModal';
import CostTrendModal from '../Modals/CostTrendModal';
import EnergyFlowModal from '../Modals/EnergyFlowModal';
import { GasMonitorContext } from '../../context';
import AiAssistant from '../../../AiAssistant';
import { ShareDataWrapperContext } from '../../../../index';
import FloatingMoreActions from '../../../FloatingMoreActions';

interface CenterBottomBoxProps {
  className?: string;
}

const MODAL_BUTTONS = [
  { key: 'energyFlow', label: '用气能流' },
  { key: 'gasTrend', label: '用气趋势' },
];

const AI_ASSISTANT_SIZE = { width: 96, height: 128 };
const AI_ASSISTANT_OFFSET = { x: 16, y: 0 };

const CenterBottomBox: React.FC<CenterBottomBoxProps> = () => {
  const { configDetail } = useContext(GasMonitorContext);
  const { isStandardSize, loadMap, scale: pageScale } = useContext(ShareDataWrapperContext);
  const buttonGroupRef = useRef<HTMLDivElement>(null);
  const isStandardNoMap = isStandardSize && !loadMap;
  const [modalVisible, setModalVisible] = useState<Record<string, boolean>>({
    energyFlow: false,
    costTrend: false,
    gasTrend: false,
  });

  const handleModalOpen = (key: string) => {
    setModalVisible({ ...modalVisible, [key]: true });
  };

  const handleModalClose = (key: string) => {
    setModalVisible({ ...modalVisible, [key]: false });
  };

  // 渲染弹窗按钮（Portal 渲染）
  const renderModalButtons = () => {
    if (isStandardNoMap) {
      return (
        <FloatingMoreActions
          rootRef={buttonGroupRef}
          actions={MODAL_BUTTONS.map(btn => ({
            key: btn.key,
            label: btn.label,
            onClick: () => handleModalOpen(btn.key),
          }))}
        />
      );
    }

    const container = document.getElementById('full_screen_box') ?? document.body;
    return createPortal(
      <div ref={buttonGroupRef} className={styles.modalButtons}>
        {MODAL_BUTTONS.map(btn => (
          <div key={btn.key} className={styles.modalBtn} onClick={() => handleModalOpen(btn.key)}>
            {btn.label}
          </div>
        ))}
      </div>,
      container
    );
  };

  return (
    <>
      {/* AI助手（可拖拽） */}
      <AiAssistant
        anchorRef={buttonGroupRef}
        placement="left-bottom"
        baseSize={AI_ASSISTANT_SIZE}
        offset={AI_ASSISTANT_OFFSET}
        pageScale={pageScale}
        enabled={!isStandardNoMap}
      />
      {renderModalButtons()}
      {/* 弹窗 */}
      <EnergyFlowModal
        open={modalVisible.energyFlow}
        onClose={() => handleModalClose('energyFlow')}
        configDetail={configDetail}
      />
      <CostTrendModal open={modalVisible.costTrend} onClose={() => handleModalClose('costTrend')} />
      <GasTrendModal open={modalVisible.gasTrend} onClose={() => handleModalClose('gasTrend')} />
    </>
  );
};

export default CenterBottomBox;
